import { resetSelect, useAccountRepository } from '@frontend/repository';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { useAppDispatch, useAppSelector } from '../../redux/store';

export const useSchedules = () => {
    const { currentAccount } = useAccountRepository();
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const currentUser = useAppSelector((state) => state.users).current;
    const [activeTab, setActiveTab] = useState<string>('my_schedules');

    useEffect(() => {
        return () => {
            dispatch(resetSelect({ listId: `${activeTab}-schedules-list` }));
        };
    }, [activeTab]);

    return {
        currentAccount,
        dispatch,
        activeTab,
        setActiveTab,
        currentUser,
        navigate,
        location
    };
};
